(function(){
'use strict';

function onReady(fn){
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',fn,{once:true});
  } else { fn(); }
}

function rafDefer(fn){
  if('requestAnimationFrame' in window){
    requestAnimationFrame(function(){ setTimeout(fn,0); });
  } else { setTimeout(fn,50); }
}

function fmtPrice(cents){
  return '\u20a8' + Math.round(cents/100).toLocaleString();
}

// ─────────────────────────────────────────────
// CORE: Fire a real native change event on an
// input so Pipeline theme.js picks it up.
// ─────────────────────────────────────────────
function fireNativeChange(el){
  // Dispatch both input + change — some themes listen to one or the other
  ['input','change'].forEach(function(evtName){
    var evt;
    try {
      evt = new Event(evtName, {bubbles:true, cancelable:true});
    } catch(e) {
      // IE fallback
      evt = document.createEvent('Event');
      evt.initEvent(evtName, true, true);
    }
    el.dispatchEvent(evt);
  });
}

// ─────────────────────────────────────────────
// Select a variant option by name + value.
// Works for BOTH radio buttons AND select dropdowns.
// Returns true if something changed.
// ─────────────────────────────────────────────
function selectOption(container, optionName, value){
  var changed = false;

  // Try radio first
  var escapedVal = value.replace(/"/g,'\\"');
  var radio = container.querySelector(
    'input[type="radio"][name="options[' + optionName + ']"][value="' + escapedVal + '"]'
  );
  if(radio){
    if(!radio.checked){
      radio.checked = true;
      fireNativeChange(radio);
      changed = true;
    }
    return changed;
  }

  // Try select dropdown
  var sel = container.querySelector(
    'select[name="options[' + optionName + ']"]'
  );
  if(sel && sel.value !== value){
    sel.value = value;
    fireNativeChange(sel);
    changed = true;
  }

  return changed;
}

// ─────────────────────────────────────────────
// Get current selected value for each option
// ─────────────────────────────────────────────
function getSelectedOptions(container, productData){
  return (productData.options || []).map(function(optName){
    var r = container.querySelector(
      'input[type="radio"][name="options[' + optName + ']"]:checked'
    );
    if(r) return r.value;
    var s = container.querySelector('select[name="options[' + optName + ']"]');
    if(s) return s.value;
    return null;
  });
}

// Find best matching variant given current option selections
function findBestVariant(variants, optValues){
  // Exact match first
  var exact = variants.filter(function(v){
    return v.options.every(function(val,i){ return optValues[i] === null || val === optValues[i]; });
  });
  if(exact.length) return exact[0];
  return null;
}

// ─────────────────────────────────────────────
// Force the hidden #id input to a variant id
// and fire change so theme picks it up
// ─────────────────────────────────────────────
function setVariantId(container, variantId){
  var hidden = container.querySelector('input[name="id"]');
  if(hidden && String(hidden.value) !== String(variantId)){
    hidden.value = String(variantId);
    fireNativeChange(hidden);
  }
}

// ─────────────────────────────────────────────
// Update price display
// ─────────────────────────────────────────────
function updatePriceDisplay(container, variant){
  var priceEl = container.querySelector('[data-product-price]');
  if(!priceEl) return;
  var html = '<span>' + fmtPrice(variant.price) + '</span>';
  if(variant.compare_at_price && variant.compare_at_price > variant.price){
    html += '<s class="product__price__was">' + fmtPrice(variant.compare_at_price) + '</s>';
  }
  priceEl.innerHTML = html;

  var btnPrice = container.querySelector('[data-button-price]');
  if(btnPrice) btnPrice.textContent = fmtPrice(variant.price);
}

// ─────────────────────────────────────────────
// DETECT which option index has per-variant images
// ─────────────────────────────────────────────
function detectColorOptionIndex(productData){
  var variants = productData.variants || [];
  var media    = productData.media    || [];
  var numOpts  = (productData.options || []).length;
  var best = -1, bestScore = 0;

  // Pass 1: featured_media coverage
  for(var i=0; i<numOpts; i++){
    var seen={}, mediaSeen={};
    variants.forEach(function(v){
      var val = v.options[i];
      if(val==null) return;
      seen[val]=true;
      var mid = v.featured_media && v.featured_media.id;
      if(mid) mediaSeen[mid]=true;
    });
    var tV=Object.keys(seen).length, tM=Object.keys(mediaSeen).length;
    if(tV>=2 && tM>=2 && tM>bestScore){ bestScore=tM; best=i; }
  }
  if(best>-1) return best;

  // Pass 2: alt-text match
  bestScore=0;
  for(var j=0; j<numOpts; j++){
    var vals=(productData.options[j] && productData.options[j].values)||[];
    var matched=0;
    vals.forEach(function(val){
      var v=(val||'').toLowerCase();
      var hit=media.some(function(m){
        var alt=(m.alt||'').toLowerCase();
        return alt===v||alt.indexOf(v)>-1;
      });
      if(hit) matched++;
    });
    if(vals.length>=2 && matched>=2 && matched>bestScore){ bestScore=matched; best=j; }
  }
  return best;
}

// ═══════════════════════════════════════
// PRODUCT PAGE INIT
// ═══════════════════════════════════════
function initProduct(){
  var container = document.querySelector('[data-section-type="product"]');
  if(!container) return;

  var slideshowEl   = container.querySelector('[data-product-slideshow]');
  var productJsonEl = container.querySelector('[data-product-json]');
  if(!productJsonEl) return;

  var productData;
  try{ productData = JSON.parse(productJsonEl.innerHTML); } catch(e){ return; }

  var variants  = productData.variants || [];
  var allMedia  = productData.media    || [];
  var colorIdx  = detectColorOptionIndex(productData);
  var numOpts   = (productData.options||[]).length;

  // Build fast lookup maps
  var idToVariant    = {};
  var mediaToVariant = {};
  variants.forEach(function(v){
    idToVariant[String(v.id)] = v;
    if(v.featured_media && v.featured_media.id){
      mediaToVariant[String(v.featured_media.id)] = v;
    }
  });

  // ── Only build color panel if there is a color-type option
  if(colorIdx > -1){
    buildColorPanel(container, productData, colorIdx, slideshowEl, idToVariant, mediaToVariant);
  }

  // ── Sticky buy bar
  initStickyBuyNow(container);

  // ── Live viewers
  rafDefer(function(){ initViewers(container); });
}

// ─────────────────────────────────────────────
// BUILD COLOR SWATCH PANEL
// ─────────────────────────────────────────────
function buildColorPanel(container, productData, colorIdx, slideshowEl, idToVariant, mediaToVariant){
  var variants    = productData.variants || [];
  var allMedia    = productData.media    || [];
  var colorOptName = productData.options[colorIdx];
  // Pipeline stores option names as strings
  if(typeof colorOptName === 'object' && colorOptName.name) colorOptName = colorOptName.name;
  var numOpts     = productData.options.length;

  // Remove old panel
  var old = document.getElementById('binbColorPanel');
  if(old) old.remove();

  // ── Hide native selector wrapper for the color option ONLY
  // Use visibility:hidden + height:0 not display:none — keeps form valid
  var nativeWrapper = container.querySelector(
    '.selector-wrapper[data-option-position="' + (colorIdx+1) + '"]'
  );
  if(nativeWrapper){
    nativeWrapper.style.cssText = 'position:absolute!important;visibility:hidden!important;height:0!important;overflow:hidden!important;pointer-events:none!important;';
  }

  // Build unique color list (first variant per color)
  var seenColors=[], colorVariants=[];
  variants.forEach(function(v){
    var c=v.options[colorIdx];
    if(seenColors.indexOf(c)===-1){ seenColors.push(c); colorVariants.push(v); }
  });
  if(!colorVariants.length) return;

  function getThumbUrl(v){
    if(v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src)
      return v.featured_media.preview_image.src;
    var c=(v.options[colorIdx]||'').toLowerCase();
    for(var i=0;i<allMedia.length;i++){
      var alt=(allMedia[i].alt||'').toLowerCase();
      if(alt===c||alt.indexOf(c)>-1)
        return allMedia[i].preview_image ? allMedia[i].preview_image.src : '';
    }
    return allMedia[0]&&allMedia[0].preview_image ? allMedia[0].preview_image.src : '';
  }

  // Determine current selected color
  var currentColorInput = container.querySelector(
    'input[type="radio"][name="options[' + colorOptName + ']"]:checked'
  );
  var currentColor = currentColorInput ? currentColorInput.value : colorVariants[0].options[colorIdx];

  // Build panel DOM
  var panel = document.createElement('div');
  panel.id        = 'binbColorPanel';
  panel.className = 'binb-color-panel';

  var header = document.createElement('div');
  header.className = 'binb-color-panel__header';
  header.innerHTML =
    '<span class="binb-color-panel__label">&#x1F3A8; Color:</span>' +
    '<span class="binb-color-panel__selected" id="binbColorName">' + currentColor + '</span>' +
    '<span class="binb-color-panel__count">' + colorVariants.length + ' options</span>';
  panel.appendChild(header);

  var swatchRow = document.createElement('div');
  swatchRow.className = 'binb-color-panel__swatches';
  swatchRow.id = 'binbColorSwatches';
  panel.appendChild(swatchRow);

  // Build swatches via DocumentFragment
  var frag = document.createDocumentFragment();
  colorVariants.forEach(function(variant){
    var color   = variant.options[colorIdx];
    var imgUrl  = getThumbUrl(variant);
    var mediaId = variant.featured_media ? String(variant.featured_media.id) : '';
    var price   = fmtPrice(variant.price);
    var hasCmp  = variant.compare_at_price && variant.compare_at_price > variant.price;

    var btn = document.createElement('button');
    btn.type      = 'button';
    btn.className = 'binb-cs' + (color===currentColor ? ' binb-cs--active' : '');
    btn.setAttribute('data-color', color);
    btn.setAttribute('data-media-id', mediaId);
    btn.title = color;

    if(imgUrl){
      var img = document.createElement('img');
      img.src      = imgUrl;
      img.alt      = color;
      img.loading  = 'lazy';
      img.width    = 56;
      img.height   = 56;
      img.decoding = 'async';
      btn.appendChild(img);
    } else {
      var fb = document.createElement('span');
      fb.className   = 'binb-cs__fallback';
      fb.textContent = color.substring(0,2);
      btn.appendChild(fb);
    }

    var nm = document.createElement('span');
    nm.className   = 'binb-cs__name';
    nm.textContent = color;
    btn.appendChild(nm);

    var pr = document.createElement('span');
    pr.className = 'binb-cs__price';
    if(hasCmp){
      pr.innerHTML = '<s>' + fmtPrice(variant.compare_at_price) + '</s> ' + price;
    } else {
      pr.textContent = price;
    }
    btn.appendChild(pr);
    frag.appendChild(btn);
  });
  swatchRow.appendChild(frag);

  // Insert panel after thumbnail wrapper or slideshow
  var thumbWrapper = container.querySelector('[data-product-thumbs]');
  if(thumbWrapper && thumbWrapper.parentNode){
    thumbWrapper.parentNode.insertBefore(panel, thumbWrapper.nextSibling);
  } else {
    var imgWrapper = container.querySelector('.product__media__wrapper');
    if(imgWrapper) imgWrapper.appendChild(panel);
    else container.appendChild(panel);
  }

  // ── Panel highlight helper
  function highlightSwatch(colorVal){
    swatchRow.querySelectorAll('.binb-cs').forEach(function(b){
      b.classList.toggle('binb-cs--active', b.getAttribute('data-color')===colorVal);
    });
    var nm = document.getElementById('binbColorName');
    if(nm) nm.textContent = colorVal;
  }

  var suppress = false;

  // ── SWATCH CLICK → update native inputs → theme does the rest
  swatchRow.addEventListener('click', function(e){
    var btn = e.target.closest('.binb-cs');
    if(!btn) return;
    var colorVal = btn.getAttribute('data-color');
    var mediaId  = btn.getAttribute('data-media-id');

    suppress = true;

    // 1. Highlight panel
    highlightSwatch(colorVal);

    // 2. Update the native radio/select — this triggers Pipeline's variant JS
    selectOption(container, colorOptName, colorVal);

    // 3. Keep other options unchanged — find matching variant
    rafDefer(function(){
      var opts = getSelectedOptions(container, productData);
      opts[colorIdx] = colorVal;
      var matched = findBestVariant(productData.variants, opts);
      if(matched){
        setVariantId(container, matched.id);
        updatePriceDisplay(container, matched);
      }
      // 4. Slideshow: jump to image
      if(mediaId && slideshowEl){
        slideshowEl.dispatchEvent(
          new CustomEvent('theme:image:change',{detail:{id:parseInt(mediaId,10)}})
        );
      }
      setTimeout(function(){ suppress=false; }, 600);
    });
  });

  // ── Watch hidden id input for external variant changes (theme.js sets it)
  var hiddenId = container.querySelector('input[name="id"]');
  if(hiddenId){
    new MutationObserver(function(){
      if(suppress) return;
      var v = idToVariant[String(hiddenId.value)];
      if(v) highlightSwatch(v.options[colorIdx]);
    }).observe(hiddenId, {attributes:true, attributeFilter:['value']});

    // Also watch via change event
    hiddenId.addEventListener('change', function(){
      if(suppress) return;
      var v = idToVariant[String(this.value)];
      if(v) highlightSwatch(v.options[colorIdx]);
    });
  }

  // ── theme:variant:change event (Pipeline fires this)
  container.addEventListener('theme:variant:change', function(e){
    if(suppress) return;
    var v = e.detail && e.detail.variant;
    if(v) highlightSwatch(v.options[colorIdx]);
  });

  // ── Flickity slideshow settle → sync panel
  function attachFlickity(){
    if(!window.Flickity) return false;
    var flkty = Flickity.data && Flickity.data(slideshowEl);
    if(!flkty) return false;
    flkty.on('settle', function(index){
      if(suppress) return;
      var cells = flkty.cells;
      if(!cells || !cells[index]) return;
      var cell   = cells[index].element;
      var midStr = cell && cell.getAttribute('data-media-id');
      if(!midStr) return;
      var matched = mediaToVariant[midStr];
      if(!matched) return;
      suppress = true;
      highlightSwatch(matched.options[colorIdx]);
      selectOption(container, colorOptName, matched.options[colorIdx]);
      setTimeout(function(){ suppress=false; }, 600);
    });
    return true;
  }

  if(!attachFlickity()){
    window.addEventListener('load', function(){
      if(!attachFlickity()) setTimeout(attachFlickity, 500);
    }, {once:true});
  }
}

// ═══════════════════════════════════════
// STICKY BUY BAR
// ═══════════════════════════════════════
function initStickyBuyNow(container){
  if(window.innerWidth > 768) return;
  if(document.getElementById('binb-sticky-bar')) return;
  var atcBtn = container
    ? container.querySelector('[data-add-to-cart]')
    : document.querySelector('[data-add-to-cart]');
  if(!atcBtn) return;

  var bar = document.createElement('div');
  bar.id = 'binb-sticky-bar';
  bar.innerHTML = '<button id="binb-sticky-buy">&#x26A1; Abhi Khareedein &mdash; COD Available</button>';
  bar.querySelector('button').addEventListener('click', function(){
    var p = document.querySelector('.shopify-payment-button__button');
    if(p) p.click(); else if(atcBtn) atcBtn.click();
  });
  document.body.appendChild(bar);

  new IntersectionObserver(function(en){
    var visible = en[0].isIntersecting;
    bar.style.display = visible ? 'none' : 'flex';
    document.body.classList.toggle('has-sticky-bar', !visible);
  }, {threshold:0.1}).observe(atcBtn);
}

// ═══════════════════════════════════════
// LIVE VIEWERS
// ═══════════════════════════════════════
function initViewers(container){
  var priceEl = (container || document).querySelector('[data-product-price]');
  if(!priceEl || document.getElementById('binb-viewers')) return;
  var v  = Math.floor(Math.random()*9)+4;
  var el = document.createElement('p');
  el.id          = 'binb-viewers';
  el.textContent = '\uD83D\uDC40 '+v+' log abhi yeh product dekh rahe hain';
  priceEl.parentNode.insertBefore(el, priceEl.nextSibling);
  setInterval(function(){
    v = Math.max(3, Math.min(25, v+(Math.random()>0.5?1:-1)));
    el.textContent = '\uD83D\uDC40 '+v+' log abhi yeh product dekh rahe hain';
  }, 5000);
}

// ═══════════════════════════════════════
// BOOT
// ═══════════════════════════════════════
function boot(){
  initProduct();
}

onReady(boot);
document.addEventListener('shopify:section:load', boot);

})();
